import { fbt } from 'fbtee'
import { CountBadge } from '../../components/CountBadge'
import { PillButton } from '../../components/PillButton'
import { crewTabLabel } from '../../lib/commonStrings'

export type ViewTab = 'schedule' | 'lineup' | 'social' | 'info' | 'afters'

export function ViewPillNav({
  view,
  onViewChange,
  crewUnread = 0,
  showAfters = false,
}: {
  view: ViewTab
  onViewChange: (v: ViewTab) => void
  crewUnread?: number
  /** Only festivals with at least one afterparty get the pill. */
  showAfters?: boolean
}) {
  return (
    <div className="flex gap-1 shrink-0 w-max">
      <PillButton active={view === 'schedule'} onClick={() => onViewChange('schedule')}>
        {fbt('Schedule', 'Pill nav label for the schedule timetable view')}
      </PillButton>
      <PillButton active={view === 'lineup'} onClick={() => onViewChange('lineup')}>
        {fbt('Lineup', 'Pill nav label for the artist lineup view')}
      </PillButton>
      <PillButton active={view === 'social'} onClick={() => onViewChange('social')}>
        <span className="inline-flex items-center gap-1.5">
          {crewTabLabel()}
          <CountBadge count={view === 'social' ? 0 : crewUnread} data-testid="crew-unread-badge" />
        </span>
      </PillButton>
      <PillButton active={view === 'info'} onClick={() => onViewChange('info')}>
        {fbt(
          'Info',
          'Pill nav label for the event info tab showing location, dates, and attendance',
        )}
      </PillButton>
      {showAfters && (
        <PillButton active={view === 'afters'} onClick={() => onViewChange('afters')}>
          {fbt('Afters', "Pill nav label for the tab listing a festival's afterparties")}
        </PillButton>
      )}
    </div>
  )
}
